import react from "react";
import {
  Col,
  DatePicker,
  Divider,
  Form,
  Input,
  Row,
  Select,
  Typography,
  theme,
} from "antd";
import {
    REGION_GROUP,
    DATA_MASTER_DATA_TYPE,
    VOC_MASTER_DATA_TYPE,
    OTHER_BUSINESS_EXPECT,
    PRODUCT_REQUIREMENT,
    OTHER_PRODUCT_EXPECT,
    OTHER_SUPPORT_EXPECT,
    CUSTOMER_SUPPORT,
    CUSTOMER_EXPECT,
    BUSINESS_REQUIRE,
    SUCCESS_CODE,

} from "../../../../lib/const";
import useMasterData from "../../../../lib/hooks/useMasterData";
import useCountry from "../../../../lib/hooks/useCountry";

import { Content } from "antd/es/layout/layout";
import Heading from "../../../../components/common/heading";

const { useToken } = theme;
const { Text } = Typography;

const CompentitorView = (value) =>{
    const { token } = useToken();
    const [form] = Form.useForm();
    const [regionGroup] = useMasterData(DATA_MASTER_DATA_TYPE, REGION_GROUP);
    const [countries] = useCountry();
    const [productRequirement] = useMasterData(
        VOC_MASTER_DATA_TYPE,
        PRODUCT_REQUIREMENT
    );
    const [otherBusinessExpect] = useMasterData(
        VOC_MASTER_DATA_TYPE,
        OTHER_BUSINESS_EXPECT
    );
    const [otherProductExpect] = useMasterData(
        VOC_MASTER_DATA_TYPE,
        OTHER_PRODUCT_EXPECT
    );
    const [otherSupportExpect] = useMasterData(
        VOC_MASTER_DATA_TYPE,
        OTHER_SUPPORT_EXPECT
    );
    const [customerSupport] = useMasterData(
        VOC_MASTER_DATA_TYPE,
        CUSTOMER_SUPPORT
    );
      const [customerExpect] = useMasterData(
        VOC_MASTER_DATA_TYPE,
        CUSTOMER_EXPECT
    );
    const [businessRequire] = useMasterData(
        VOC_MASTER_DATA_TYPE,
        BUSINESS_REQUIRE
    );
    const {
        header,
        dataSource,
    } = value
    return (
        <Content>
            <Row gutter={[16, 8]} className="card">
                <Col span={24}>
                <Heading
                    text={header}
                    size={4}
                    style={{ margin: 0, color: token.thPrimary }}
                />
                <Divider />
                </Col>
                <Col span={16}>
                    <Form.Item
                    label={<Text className="pr_green">ชื่อสถานประกอบการ/ชื่อโรงงาน (TH)</Text>}
                    name={"factoryNameTh"}
                    >
                    {dataSource.factoryNameTh}
                    </Form.Item>
                </Col>

                <Col span={16}>
                    <Form.Item
                    label={<Text className="pr_green">ชื่อสถานประกอบการ/ชื่อโรงงาน (EN)</Text>}
                    name={"factoryNameEn"}
                    
                    >
                    {dataSource.factoryNameEn}
                    </Form.Item>
                </Col>
                <Col span={16}>
                    <Form.Item
                    label={<Text className="pr_green">กลุ่มลูกค้าตามสัญชาติ (ตอบได้มากกว่า 1 ข้อ)</Text>}
                    name={"customerGroupByRegion"}
                    
                    >
                    {dataSource.customerGroupByRegion
                      ? regionGroup.map((item, _index) => {
                          let arr = dataSource?.customerGroupByRegion;
                          let value = [];
                          for (let i = 0; i < arr.length; i++) {
                            if (arr[i] === item.dataId) {
                              let _comma = "";
                              if (_index + 1 < dataSource?.customerGroupByRegion?.length) {
                                _comma = ", ";
                              }
                              value.push(item.dataDetailTh + _comma);
                            }
                          }
                          return value;
                        })
                      : "-"}
                     
                    {/* <Select
                        allowClear
                        mode="multiple"
                        maxTagCount={"responsive"}
                        style={{
                        width: "100%",
                        }}
                        placeholder="กรุณาเลือก"
                    >
                        {regionGroup.map((item) => (
                        <Option value={item.dataId}>{item.dataDetailTh}</Option>
                        ))}
                    </Select> */}
                    </Form.Item>
                </Col>
                <Col span={16}>
                    <Form.Item
                    label={<Text className="pr_green">สัญชาติลูกค้า (ประเทศ)</Text>}
                    name={"customerRegion"}
                    
                    >
                    {dataSource.customerRegion
                    ? countries.map((item, _index) => {
                        if (dataSource.customerRegion === item.countryId)
                        {
                        return item.countryNameTh;}
                    })
                    : "-"}
                    {/* <Select
                        allowClear
                        style={{
                        width: "100%",
                        }}
                        placeholder="กรุณาเลือก"
                    >
                        {countries.map((item) => (
                        <Option key={item.countryId} value={item.countryId}>
                            {item.countryNameTh}
                        </Option>
                        ))}
                    </Select> */}
                    {/* <MultipleAutoComplete
                        multiple={false}
                        subject="countryOrderNameTh"
                        valueField="countryId"
                        labelField="countryNameTh"
                        placeholder="กรุณาเลือก"
                    /> */}
                    </Form.Item>
                </Col>
                <Col span={24}>
                    <Divider dashed />
                </Col>
                <Heading
                    text={"ข้อคำถาม"}
                    size={4}
                    style={{ margin: 0, color: token.thPrimary }}
                />    
                <Col span={24}>
                    <Divider dashed />
                </Col>
                <Col span={24}>
                    <div style={{ fontWeight: 600, fontSize: 16 }}>
                        ด้านผลิตภัณฑ์และบริการ
                    </div>
                </Col>
                <Col span={24}>
                    <Form.Item
                        label={<Text className="pr_green">1.ลูกค้ามีความต้องการ ด้านผลิตภัณฑ์และบริการ ของ กนอ. อย่างไร (ตอบได้มากกว่า 1 ข้อ)</Text>}
                        name={["productAndServiceWant"]}
                        
                    >
                        
                      {dataSource.productAndServiceWant
                        ? productRequirement
                            .filter(item => dataSource.productAndServiceWant.includes(item.vocUniqueId))
                            .map((item, index) => (
                                <div key={item.vocUniqueId}>1.{index + 1}. {item.vocDetailTh}</div>
                            ))
                        : "-"}
                        {/* <Select
                        allowClear
                        mode="multiple"
                        maxTagCount={"responsive"}
                        style={{
                            width: "100%",
                        }}
                        placeholder="กรุณาเลือก"
                        >
                        {productRequirement &&
                            productRequirement.map((item) => (
                            <Option
                                key={item.vocUniqueId}
                                value={item.vocUniqueId}
                            >
                                {item.vocDetailTh}
                            </Option>
                            ))}
                        </Select> */}
                    </Form.Item>
                    {form.getFieldValue(["productAndServiceWant"]) &&
                        form
                        .getFieldValue(["productAndServiceWant"])
                        .includes("-99") === true && (
                        <Form.Item
                            label=""
                            name={[
                            "productAndServiceWantSpecify",
                            ,
                            ]}
                            style={{ marginTop: 8 }}
                        >
                            <Input.TextArea placeholder="รายละเอียด (อื่นๆ)" />
                        </Form.Item>
                        )}
                    </Col>
                    <Col span={24}>
                    <Form.Item
                        label={<Text className="pr_green">2.ลูกค้ามีความคาดหวังที่นอกเหนือจากความต้องการ ด้านผลิตภัณฑ์และบริการ ของ กนอ. อย่างไร (ตอบได้มากกว่า 1 ข้อ)</Text>}
                        name={["productAndServiceExpected", ]}
                    >
                        {dataSource.productAndServiceExpected
                        ? otherProductExpect
                            .filter(item => dataSource.productAndServiceExpected.includes(item.vocUniqueId))
                            .map((item, index) => (
                                <div key={item.vocUniqueId}>2.{index + 1}. {item.vocDetailTh}</div>
                            ))
                        : "-"}
                        {/* <Select
                        allowClear
                        mode="multiple"
                        maxTagCount={"responsive"}
                        style={{
                            width: "100%",
                        }}
                        placeholder="กรุณาเลือก"
                        >
                        {otherProductExpect &&
                            otherProductExpect.map((item) => (
                            <Option
                                key={item.vocUniqueId}
                                value={item.vocUniqueId}
                            >
                                {item.vocDetailTh}
                            </Option>
                            ))}
                        </Select> */}
                    </Form.Item>
                    {form.getFieldValue([
                        "productAndServiceExpected"
                    ]) &&
                        form
                        .getFieldValue(["productAndServiceExpected"])
                        .includes("-99") === true && (
                        <Form.Item
                            label=""
                            name={[
                            "productAndServiceExpectedSpecify",
                            ,
                            ]}
                            style={{ marginTop: 8 }}
                        >
                            <Input.TextArea placeholder="รายละเอียด (อื่นๆ)" />
                        </Form.Item>
                        )}
                    </Col>

                    <Col span={24}>
                    <div
                        style={{
                        fontWeight: 600,
                        fontSize: 16,
                        marginTop: 20,
                        }}
                    >
                        ด้านสนับสนุนลูกค้า
                    </div>
                    </Col>
                    <Col span={24}>
                    <Form.Item
                        label={<Text className="pr_green">1.ลูกค้ามีความต้องการ ด้านสนับสนุนลูกค้า ของ กนอ. อย่างไร (ตอบได้มากกว่า 1 ข้อ)</Text>}
                        name={["supportWant", ]}
                        
                    >
                        {dataSource.supportWant
                        ? customerSupport
                            .filter(item => dataSource.supportWant.includes(item.vocUniqueId))
                            .map((item, index) => (
                                <div key={item.vocUniqueId}>1.{index + 1}. {item.vocDetailTh}</div>
                            ))
                        : "-"}
                        {/* <Select
                        allowClear
                        mode={"multiple"}
                        maxTagCount={"responsive"}
                        style={{
                            width: "100%",
                        }}
                        placeholder="กรุณาเลือก"
                        >
                        {customerSupport &&
                            customerSupport.map((item) => (
                            <Option
                                key={item.vocUniqueId}
                                value={item.vocUniqueId}
                            >
                                {item.vocDetailTh}
                            </Option>
                            ))}
                        </Select> */}
                    </Form.Item>
                    {form.getFieldValue(["supportWant"]) &&
                        form
                        .getFieldValue(["supportWant"])
                        .includes("-99") === true && (
                        <Form.Item
                            label=""
                            name={["supportWantSpecify", ]}
                            style={{ marginTop: 8 }}
                        >
                            <Input.TextArea placeholder="รายละเอียด (อื่นๆ)" />
                        </Form.Item>
                        )}
                    </Col>
                    <Col span={24}>
                    <Form.Item
                        label={<Text className="pr_green">2.ลูกค้ามีความคาดหวังที่นอกเหนือจากความต้องการ ด้านสนับสนุนลูกค้า ของ กนอ. อย่างไร (ตอบได้มากกว่า 1 ข้อ)</Text>}
                        name={["supportExpected", ]}
                    >
                        {dataSource.supportExpected
                        ? otherSupportExpect
                            .filter(item => dataSource.supportExpected.includes(item.vocUniqueId))
                            .map((item, index) => (
                                <div key={item.vocUniqueId}>2.{index + 1}. {item.vocDetailTh}</div>
                            ))
                        : "-"}
                        {/* <Select
                        allowClear
                        mode={"multiple"}
                        maxTagCount={"responsive"}
                        style={{
                            width: "100%",
                        }}
                        placeholder="กรุณาเลือก"
                        >
                        {otherSupportExpect &&
                            otherSupportExpect.map((item) => (
                            <Option
                                key={item.vocUniqueId}
                                value={item.vocUniqueId}
                            >
                                {item.vocDetailTh}
                            </Option>
                            ))}
                        </Select> */}
                    </Form.Item>
                    {form.getFieldValue(["supportExpected"]) &&
                        form
                        .getFieldValue(["supportExpected"])
                        .includes("-99") === true && (
                        <Form.Item
                            label=""
                            name={["supportExpectedSpecify", ]}
                            style={{ marginTop: 8 }}
                        >
                            <Input.TextArea placeholder="รายละเอียด (อื่นๆ)" />
                        </Form.Item>
                        )}
                    </Col>

                    <Col span={24}>
                    <div
                        style={{
                        fontWeight: 600,
                        fontSize: 16,
                        marginTop: 20,
                        }}
                    >
                        ด้านการทำธุรกรรม
                    </div>
                    </Col>
                    <Col span={24}>
                    <Form.Item
                        label={<Text className="pr_green">1.ลูกค้ามีความต้องการ ด้านการทำธุรกรรม (อนุมัติอนุญาตสิทธิประโยชน์) ของ กนอ. อย่างไร (ตอบได้มากกว่า 1 ข้อ)</Text>}
                        name={["transactionWant", ]}
                        
                    >
                        {dataSource.transactionWant
                        ? businessRequire
                            .filter(item => dataSource.transactionWant.includes(item.vocUniqueId))
                            .map((item, index) => (
                                <div key={item.vocUniqueId}>1.{index + 1}. {item.vocDetailTh}</div>
                            ))
                        : "-"}
                        {/* <Select
                        allowClear
                        mode={"multiple"}
                        maxTagCount={"responsive"}
                        style={{
                            width: "100%",
                        }}
                        placeholder="กรุณาเลือก"
                        >
                        {businessRequire &&
                            businessRequire.map((item) => (
                            <Option
                                key={item.vocUniqueId}
                                value={item.vocUniqueId}
                            >
                                {item.vocDetailTh}
                            </Option>
                            ))}
                        </Select> */}
                    </Form.Item>
                    {form.getFieldValue(["transactionWant"]) &&
                        form
                        .getFieldValue(["transactionWant"])
                        .includes("-99") === true && (
                        <Form.Item
                            label=""
                            name={["transactionWantSpecify", ]}
                            style={{ marginTop: 8 }}
                        >
                            <Input.TextArea placeholder="รายละเอียด (อื่นๆ)" />
                        </Form.Item>
                        )}
                    </Col>
                    <Col span={24}>
                    <Form.Item
                        label={<Text className="pr_green">2.ลูกค้ามีความคาดหวังที่นอกเหนือจากความต้องการ ด้านการทำธุรกรรม (อนุมัติอนุญาตสิทธิประโยชน์) ของ กนอ. อย่างไร (ตอบได้มากกว่า 1 ข้อ)</Text>}
                        name={["transactionExpected", ]}
                    >
                        {dataSource.transactionExpected
                        ? otherBusinessExpect
                            .filter(item => dataSource.transactionExpected.includes(item.vocUniqueId))
                            .map((item, index) => (
                                <div key={item.vocUniqueId}>2.{index + 1}. {item.vocDetailTh}</div>
                            ))
                        : "-"}
                        {/* <Select
                        allowClear
                        style={{
                            width: "100%",
                        }}
                        placeholder="กรุณาเลือก"
                        maxTagCount={"responsive"}
                        mode={"multiple"}
                        >
                        {otherBusinessExpect &&
                            otherBusinessExpect.map((item) => (
                            <Option
                                key={item.vocUniqueId}
                                value={item.vocUniqueId}
                            >
                                {item.vocDetailTh}
                            </Option>
                            ))}
                        </Select> */}
                    </Form.Item>
                    {form.getFieldValue(["transactionExpected"]) &&
                        form
                        .getFieldValue(["transactionExpected"])
                        .includes("-99") === true && (
                        <Form.Item
                            label=""
                            name={["transactionExpectedSpecify", ]}
                            style={{ marginTop: 8 }}
                        >
                            <Input.TextArea placeholder="รายละเอียด (อื่นๆ)" />
                        </Form.Item>
                        )}
                    </Col>

                    <Col span={24}>
                    <div
                        style={{
                        fontWeight: 600,
                        fontSize: 16,
                        marginTop: 20,
                        }}
                    >
                        ด้านการจัดการความสัมพันธ์ (CRM)
                    </div>
                    </Col>
                    <Col span={24}>
                    <Form.Item
                        label={<Text className="pr_green">1.ลูกค้ามีความต้องการ/คาดหวัง ด้านการจัดการความสัมพันธ์(CRM) ของ กนอ. อย่างไร (ตอบได้มากกว่า 1 ข้อ)</Text>}
                        name={["crmExpected", ]}
                        
                    >
                        {dataSource.crmExpected
                        ? customerExpect
                            .filter(item => dataSource.crmExpected.includes(item.vocUniqueId))
                            .map((item, index) => (
                                <div key={item.vocUniqueId}>1.{index + 1}. {item.vocDetailTh}</div>
                            ))
                        : "-"}
                        {/* <Select
                        allowClear
                        style={{
                            width: "100%",
                        }}
                        placeholder="กรุณาเลือก"
                        mode={"multiple"}
                        maxTagCount={"responsive"}
                        >
                        {customerExpect &&
                            customerExpect.map((item) => (
                            <Option
                                key={item.vocUniqueId}
                                value={item.vocUniqueId}
                            >
                                {item.vocDetailTh}
                            </Option>
                            ))}
                        </Select> */}
                    </Form.Item>
                    {form.getFieldValue(["crmExpected"]) &&
                        form
                        .getFieldValue(["crmExpected"])
                        .includes("-99") === true && (
                        <Form.Item
                            label=""
                            name={["crmExpectedSpecify", ]}
                            style={{ marginTop: 8 }}
                        >
                            <Input.TextArea placeholder="รายละเอียด (อื่นๆ)" />
                        </Form.Item>
                        )}
                    </Col>
                    <Col span={24}>
                    <Form.Item
                        label={<Text className="pr_green">2.ข้อเสนอแนะด้านผลิตภัณฑ์และบริการ (ถ้ามี)</Text>}
                        name={["productAndServiceSuggestion", ]}
                    >
                       2. {dataSource.productAndServiceSuggestion}
                    </Form.Item>
                    </Col>
                    <Col span={24}>
                    <Form.Item
                        label={<Text className="pr_green">3.ข้อเสนอแนะด้านสนับสนุนลูกค้า (ถ้ามี)</Text>}
                        name={["supportSuggestion", ]}
                    >
                       3. {dataSource.supportSuggestion}
                    </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            label={<Text className="pr_green">4.ข้อเสนอแนะด้านการทำธุรกรรม (อนุมัติ, อนุญาตและสิทธิประโยชน์) (ถ้ามี)</Text>}
                            name={["transactionSuggestion", ]}
                        >
                        4. {dataSource.transactionSuggestion}
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            label={<Text className="pr_green">5.ข้อเสนอแนะด้านการจัดการความสัมพันธ์กับลูกค้า (CRM) (ถ้ามี)</Text>}
                            name={["crmSuggestion", ]}
                        >
                        5. {dataSource.crmSuggestion}
                    </Form.Item>
                    </Col>
                    <Col span={24}>
                    <Form.Item
                        label={<Text className="pr_green">6.สิ่งที่ไม่พึ่งพอใจต้องการให้ปรับปรุงอย่างเร่งด่วน (ถ้ามี)</Text>}
                        name={["notSatisfied", ]}
                    >
                       6. {dataSource.notSatisfied}
                    </Form.Item>
                </Col>
            </Row>
        </Content>
    )
}
export default CompentitorView;